"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTooltipInfomationTitle = void 0;
var _defineType = require("../_util/defineType");
const isTooltipInfomationTitle = data => {
  return Array.isArray(data) && data.every(item => (0, _defineType.isObject)(item) && item.hasOwnProperty('label'));
};
exports.isTooltipInfomationTitle = isTooltipInfomationTitle;